import { Link } from 'react-router-dom';

interface ComicCardProps {
  slug: string;
  title: string;
  author: string;
  cover: string;
  rating: number;
  status: string;
  updatedAt?: string;
  latestChapter?: number;
  variant?: 'default' | 'compact' | 'featured';
}

export default function ComicCard({
  slug,
  title,
  author,
  cover,
  rating,
  status,
  updatedAt,
  latestChapter,
  variant = 'default',
}: ComicCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/comic/${slug}`}
        className="group block cursor-pointer"
      >
        <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-2">
          <img
            src={cover}
            alt={title}
            title={`${title} - 韩国漫画`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
          <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md font-label">
            {rating}分
          </div>
          <div className="absolute bottom-2 left-2 right-2">
            <p className="text-background-50 text-sm font-medium truncate">{title}</p>
            {latestChapter && (
              <p className="text-background-300 text-xs mt-0.5">更新至{latestChapter}话</p>
            )}
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'featured') {
    return (
      <Link
        to={`/comic/${slug}`}
        className="group block cursor-pointer"
      >
        <div className="relative rounded-xl overflow-hidden bg-background-50">
          <div className="aspect-[3/4]">
            <img
              src={cover}
              alt={title}
              title={`${title} - 韩国漫画`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <span className="inline-block bg-accent-500 text-background-50 text-xs px-2 py-1 rounded-md mb-2 font-label">
              编辑精选
            </span>
            <h3 className="text-background-50 text-lg font-bold">{title}</h3>
            <p className="text-background-200 text-sm">{author}</p>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/comic/${slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
        <img
          src={cover}
          alt={title}
          title={`${title} - 韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/5 to-transparent"></div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-amber-500 text-xs"></i>
          <span className="text-foreground-800 text-xs font-semibold font-label">{rating}</span>
        </div>
        {status === '已完结' && (
          <div className="absolute top-2 left-2 bg-foreground-800/80 backdrop-blur-sm text-background-50 text-xs px-2 py-0.5 rounded-md font-label">
            已完结
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-background-50 text-sm font-semibold truncate">{title}</h3>
          <div className="flex items-center justify-between mt-1">
            <span className="text-background-300 text-xs">{author}</span>
            {latestChapter && (
              <span className="text-accent-300 text-xs font-label">至{latestChapter}话</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}